import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import IconeHay from "../images/logo-loading.png";
import { Link } from 'react-router-dom';
import utilService from '../service/UtilService';
import { toast } from 'react-toastify';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import ApiService from '../service/ApiService';
import { Card } from 'primereact/card';
import { InputOtp } from 'primereact/inputotp';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { withRouter } from '../ganchos/withRouter';
import { useKeyboard } from '../ganchos/useKeyboard';


class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            codigo: '',
            errovisivel: false
        }
    }

    pressionar(numero) {
        if (this.state.codigo?.length < 5) {
            this.setState({ codigo: this.state.codigo + String(numero) });
        }

    }
    apagar() {
        if (this.state.codigo) {
            this.setState({ codigo: this.state.codigo.slice(0, -1) });
        }
    }
    async validarCodigo() {
        if (this.state.codigo?.length < 5) {
            return this.setState({ errovisivel: true, erro: 'O codigo informado não está completo. Digite o código de 5 caracteres, recebido após o formulário preenchido no Assistente Virtual Bella da Cabonnet.' });
        }
        const codigoValido = await ApiService.validarCodigoEvento({
            evento: this.props.operacaoTotem?.evento?.id,
            codigo: this.state.codigo
        });

        switch (codigoValido.state) {
            case "menu.mensagem.codigo.nao.encontrado":
                return this.setState({ errovisivel: true, erro: 'O codigo informado não pertence a nenhum cadastro de participante válido. Digite o código de 5 caracteres, recebido após o formulário preenchido no Assistente Virtual Bella da Cabonnet.' });
                break;
            case "menu.mensagem.esse.participante.ja.participou.do.sorteio":
                return this.setState({ errovisivel: true, erro: 'O codigo informado já foi utilizado para este sorteio. Você pode participar do sorteio apenas uma vez. Fique atento para os próximos eventos.' });
                break;
            case "menu.mensagem.evento.nao.esta.ativo":
                return this.setState({ errovisivel: true, erro: 'O evento não econtra-se mais ativo no momento. Entre em contato com a nossa equipe.' });
            case "menu.mensagem.realizar.sorteio":
                this.props.onEventoParticipante(codigoValido.eventoParticipante, codigoValido.premios);
                return this.props.navigate("/sorteio/" + this.props.operacaoTotem.id);
                break;
        }
    }

    aoSoltarTecla = (evento) => {
        switch(evento.key){
            case "1":
            case "2":
            case "3":
            case "4":
            case "5":
            case "6":
            case "7":
            case "8":
            case "9":
            case "0":
                return this.pressionar(evento.key);
            case "Backspace":
                return this.apagar();
            case "Enter":
                return this.validarCodigo();
        }
    }

    componentDidMount(){
        window.addEventListener('keyup', this.aoSoltarTecla);
    }
    componentWillUnmount(){
        window.removeEventListener('keyup', this.aoSoltarTecla);
    }
    render() {
        const settings = {
            type: 'loop',
            autoplay: true,
            width: '100%'
        };
        return (
            <>

                <ul id="progress-bar" className="entry-bookend-progress-container header fundo-inicial" >
                    {this.props.operacaoTotem?.modooperacao == 'main.operacaototem.modooperacao.autoatendimento' && !this.props.operacaoTotem?.campanhaVisoes?.length &&
                        <>
                            <img alt="Logo da Hay Systems" src={this.props.operacaoTotem?.logoPrincipalAutoAtendimento || IconeHay} />
                            <p className="boas-vindas" style={utilService.reactShow(this.props.operacaoTotem?.id)}> {this.props.operacaoTotem?.mensagemBoasVindasAutoAtendimento || "Bem-vindo ao sistema de auto-atendimento."}</p>
                            <p className="boas-vindas" style={utilService.reactShow(!this.props.operacaoTotem?.id)}>Acesso não autorizado.</p>
                        </>
                    }
                    {this.props.operacaoTotem?.modooperacao != 'main.operacaototem.modooperacao.evento' && this.props.operacaoTotem?.campanhaVisoes?.length &&
                        <Splide options={settings}>
                            {
                                this.props.operacaoTotem?.campanhaVisoes?.map(cV => {
                                    return (
                                        <SplideSlide>
                                            <img src={ApiService.urlBase + cV.imagem} className="imagem-carrousel" alt="Image 1" />
                                        </SplideSlide>
                                    )
                                })
                            }
                        </Splide>
                    }
                    {this.props.operacaoTotem?.modooperacao == 'main.operacaototem.modooperacao.autoatendimento' &&
                        <Link to={"/identificacao/" + this.props.operacaoTotem.id} style={utilService.reactShow(this.props.operacaoTotem?.id)} className="botao-autoatendimento primario home-botao" onClick={() => this.props.contrato?.contratoid && utilService.iniciarTimerSessao(this.props.aoExpirar, toast)}>
                            <FontAwesomeIcon className={"fa-fw index unselectable"} size="1x" icon={"fa-arrow-right-from-bracket"} />  Toque para começar
                        </Link>
                    }
                    {this.props.operacaoTotem?.modooperacao == 'main.operacaototem.modooperacao.evento' && this.props.operacaoTotem?.evento?.id &&

                        <div className="flex flex-row">

                            <Card title="Quer participar?" className="flex-1 lg:m-4 m-2">
                                <div className="flex flex-column align-items-center gap-4">

                                    <div className="flex-1">
                                        <p className="text-sm md:text-base line-height-3 m-0">
                                            Leia o QR Code abaixo e você será direcionado para nossa assistente virtual, a Bella.
                                            Faça seu cadastro rapidinho, receba seu código e insira no campo ao lado para
                                            concorrer a prêmios incríveis. Vamos lá?
                                        </p>
                                    </div>

                                    <div className="flex justify-content-center">
                                        <img
                                            className="w-full md:w-10"
                                            src={ApiService.urlBase + this.props.operacaoTotem?.evento?.imageqrcode}
                                            alt="QR Code do evento"
                                        />
                                    </div>

                                </div>
                            </Card>
                            <Card title="Cadastro Pronto?" className="flex-1 lg:m-4 m-2">
                                <p className="">
                                    Insira o código que voce recebeu de 5 digitos para receber uma chance única de ganhar prêmios incríveis.
                                </p>
                                <div className="flex flex-row">
                                    <div className="flex-1"></div>
                                    <InputOtp className="flex-1" value={this.state.codigo} length={5} inputTemplate={({ events, props }) => <input {...events} {...props} type="text" className="custom-otp-input" />} />
                                    <div className="flex-1"></div>
                                </div>
                                <div className='mt-5 mx-5'>
                                    {/* <ul className="entry-bookend-progress-container header botoes-identificacao"  style={{ width: "100%" }}>
                                        <li className="progress-item progress-step" title={"Pressionar 1"} onClick={() => this.pressionar(1)}>
                                            <span className="circle progress-index numero" >
                                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                    <FontAwesomeIcon className={"fa-fw index unselectable"} size="5x" icon={"circle"} />
                                                    <span class="fa-layers-text fa-2x unselectable" style={{ fontWeight: 900 }}> 1 </span>
                                                </span>
                                            </span>
                                        </li>
                                        <li className="progress-item progress-step" title={"Pressionar 2"} onClick={() => this.pressionar(2)}>
                                            <span className="circle progress-index numero" >
                                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                    <FontAwesomeIcon className={"fa-fw index unselectable"} size="5x" icon={"circle"} />
                                                    <span class="fa-layers-text fa-2x unselectable" style={{ fontWeight: 900 }}> 2 </span>
                                                </span>
                                            </span>
                                        </li>
                                        <li className="progress-item progress-step" title={"Pressionar 3"} onClick={() => this.pressionar(3)}>
                                            <span className="circle progress-index numero" >
                                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                    <FontAwesomeIcon className={"fa-fw index unselectable"} size="5x" icon={"circle"} />
                                                    <span class="fa-layers-text fa-2x unselectable" style={{ fontWeight: 900 }}> 3 </span>
                                                </span>
                                            </span>
                                        </li>
                                        <li className='break'></li>
                                        <li className="progress-item progress-step" title={"Pressionar 4"} onClick={() => this.pressionar(4)}>
                                            <span className="circle progress-index numero" >
                                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                    <FontAwesomeIcon className={"fa-fw index unselectable"} size="5x" icon={"circle"} />
                                                    <span class="fa-layers-text fa-2x unselectable" style={{ fontWeight: 900 }}> 4 </span>
                                                </span>
                                            </span>
                                        </li>
                                        <li className="progress-item progress-step" title={"Pressionar 5"} onClick={() => this.pressionar(5)}>
                                            <span className="circle progress-index numero" >
                                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                    <FontAwesomeIcon className={"fa-fw index unselectable"} size="5x" icon={"circle"} />
                                                    <span class="fa-layers-text fa-2x unselectable" style={{ fontWeight: 900 }}> 5 </span>
                                                </span>
                                            </span>
                                        </li>
                                        <li className="progress-item progress-step" title={"Pressionar 6"} onClick={() => this.pressionar(6)}>
                                            <span className="circle progress-index numero" >
                                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                    <FontAwesomeIcon className={"fa-fw index unselectable"} size="5x" icon={"circle"} />
                                                    <span class="fa-layers-text fa-2x unselectable" style={{ fontWeight: 900 }}> 6 </span>
                                                </span>
                                            </span>
                                        </li>
                                        <li className='break'></li>
                                        <li className="progress-item progress-step" title={"Pressionar 7"} onClick={() => this.pressionar(7)}>
                                            <span className="circle progress-index numero" >
                                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                    <FontAwesomeIcon className={"fa-fw index unselectable"} size="5x" icon={"circle"} />
                                                    <span class="fa-layers-text fa-2x unselectable" style={{ fontWeight: 900 }}> 7 </span>
                                                </span>
                                            </span>
                                        </li>
                                        <li className="progress-item progress-step" title={"Pressionar 8"} onClick={() => this.pressionar(8)}>
                                            <span className="circle progress-index numero" >
                                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                    <FontAwesomeIcon className={"fa-fw index unselectable"} size="5x" icon={"circle"} />
                                                    <span class="fa-layers-text fa-2x unselectable" style={{ fontWeight: 900 }}> 8 </span>
                                                </span>
                                            </span>
                                        </li>
                                        <li className="progress-item progress-step"  title={"Pressionar 9"} onClick={() => this.pressionar(9)}>
                                            <span className="circle progress-index numero" >
                                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                    <FontAwesomeIcon className={"fa-fw index unselectable"} size="5x" icon={"circle"} />
                                                    <span class="fa-layers-text fa-2x unselectable" style={{ fontWeight: 900 }}> 9 </span>
                                                </span>
                                            </span>
                                        </li>
                                        <li className='break'></li>
                                        <li className="progress-item progress-step" title={"Apagar"} onClick={() => this.apagar()}>

                                            <span className="circle progress-index numero" >
                                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                    <FontAwesomeIcon className={"fa-fw index unselectable"} size="2x" icon={"circle"} transform="right-3" style={{ color: "red" }} />
                                                    <FontAwesomeIcon className={"fa-fw index unselectable"} size="4x" icon={"delete-left"} />
                                                </span>
                                            </span>
                                        </li>
                                        <li className="progress-item progress-step" title={"Pressionar 0"} onClick={() => this.pressionar(0)}>
                                            <span className="circle progress-index numero" >
                                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                    <FontAwesomeIcon className={"fa-fw index unselectable"} size="5x" icon={"circle"} />
                                                    <span class="fa-layers-text fa-2x unselectable" style={{ fontWeight: 900 }}> 0 </span>
                                                </span>
                                            </span>
                                        </li>
                                        <li className="progress-item progress-step" title={"Iniciar Sorteio"} onClick={() => this.validarCodigo()} >
                                            <span className="circle progress-index numero" >
                                                <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                    <FontAwesomeIcon className={"fa-fw index unselectable"} size="4x" icon={"circle"} style={{ color: this.state.codigo.length == 5 ? "lime" : 'blue' }} />
                                                    <FontAwesomeIcon className={"fa-fw index unselectable"} size="5x" icon={"circle-check"} />
                                                </span>
                                            </span>
                                        </li>
                                    </ul> */}
                                    <div className="teclado-container">
                                        <div className="teclado-grid">
                                            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => (

                                                <li className="progress-item progress-step" title={"Pressionar " + num} onClick={() => this.pressionar(num)}>
                                                    <span className="circle progress-index numero" >
                                                        <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                            <FontAwesomeIcon className={"fa-fw index unselectable"} size="5x" icon={"circle"} />
                                                            <span class="fa-layers-text fa-2x unselectable" style={{ fontWeight: 900 }}> {num} </span>
                                                        </span>
                                                    </span>
                                                </li>
                                            ))}

                                            {/* Apagar */}
                                            <li className="progress-item progress-step" title={"Apagar"} onClick={() => this.apagar()}>
                                                <span className="circle progress-index numero" >
                                                    <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                        <FontAwesomeIcon className={"fa-fw index unselectable"} size="2x" icon={"circle"} transform="right-3" style={{ color: "red" }} />
                                                        <FontAwesomeIcon className={"fa-fw index unselectable"} size="4x" icon={"delete-left"} />
                                                    </span>
                                                </span>
                                            </li>

                                            {/* 0 */}
                                            <li className="progress-item progress-step" title={"Pressionar 0"} onClick={() => this.pressionar(0)}>
                                                <span className="circle progress-index numero" >
                                                    <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                        <FontAwesomeIcon className={"fa-fw index unselectable"} size="5x" icon={"circle"} />
                                                        <span class="fa-layers-text fa-2x unselectable" style={{ fontWeight: 900 }}> 0 </span>
                                                    </span>
                                                </span>
                                            </li>

                                            {/* Confirmar */}
                                            <li className="progress-item progress-step" title={"Iniciar Sorteio"} onClick={() => this.validarCodigo()} >
                                                <span className="circle progress-index numero" >
                                                    <span class="fa-layers fa-fw" style={{ width: "100%", height: "100%" }} >
                                                        <FontAwesomeIcon className={"fa-fw index unselectable"} size="4x" icon={"circle"} style={{ color: this.state.codigo.length == 5 ? "lime" : 'blue' }} />
                                                        <FontAwesomeIcon className={"fa-fw index unselectable"} size="5x" icon={"circle-check"} />
                                                    </span>
                                                </span>
                                            </li>
                                        </div>
                                    </div>
                                </div>
                                <Dialog onShow={()=> this.componentWillUnmount() } 
                                        header="Codigo Inválido" 
                                        draggable={false} closable={false}
                                        visible={this.state.errovisivel} 
                                        footer={() => <div>
                                            <Button label="&nbsp;Ok" 
                                                    icon={<FontAwesomeIcon className={"fa-fw index unselectable"} icon={"circle-check"} />} 
                                                    onClick={() => this.setState({ errovisivel: false }, async ()  => { 
                                                        await utilService.aguardar(300);
                                                        this.componentDidMount();
                                                    })} 
                                                    autoFocus /> 
                                        </div>}
                                        style={{ width: '25vw' }}
                                        breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                                    <p className="m-0">
                                        {this.state.erro}
                                    </p>
                                </Dialog>
                            </Card>
                        </div>
                    }

                </ul>

            </>
        )
    }
}
export default withRouter(Home);
